// src/mixins/postTimeSelection.js

import { mapGetters } from "vuex";

export default {
  data: function() {
    return {
      timeSlotId: null,
      //timeSlotRequirements: []
    };
  },
  mounted() {
    if (!this.time) {
      console.warn("this.time must be defined in the component that uses mixins/postTimeSelection.js");
    }
    if (!this.activity) {
      //alert("this.activity must be defined for postTimeSelection.js");
    }
  },

  methods: {
    //...mapMutations(['mutateTimeSlotRequirements']),

    advancePostTimeSelection(comingFrom, timeSlotId, route) {
      this.timeSlotId = timeSlotId;

      if (!this.timeMix) {
        console.log("no this.timeMix at advancePostTimeSelection()");
      }
      var client = route.params.client;

      var productType = this.activeProductDetails.PackageKey && !this.activeProductDetails.ShowFirstActivityOnly ? "/package/" : "/activity/";

      var p = "/" + client + productType + route.params.modify + "/" + route.params.id + "/" + route.params.clientAgentKey;
      // console.log('p: ' + p);

      var find = this.timeSlotRequirements.find((ele) => {
        return ele.valid != true && ele.required == true;
      });

      console.log("find", find);

      if (find) {
        //          console.log ('need to select: ' + find.page);

        var ehk = this.activeProductDetails.EntityHierarchyKey ? this.activeProductDetails.EntityHierarchyKey : this.entityHierarchyKey;
        console.log("ehk :>>", ehk);

        if (find.page == "addOns" && comingFrom != "addOns") {
          // go to addOns

          p = p + "/addons/" + ehk + "/" + this.timeMix.Value;

          this.$router.push({
            path: p,
          });
        } else if (find.page == "pickupLocation" && comingFrom != "comingFrom") {
          p = p + "/transportation/" + this.activeProductDetails.EntityHierarchyKey + "/" + this.timeMix.Value;

          //console.log('Browsing to: ' + p);

          this.$router.push({
            path: p,
          });
        } else if (find.page == "pickupLocation") {
          p =
            p +
            "/transportation/" +
            //this.activeProductDetails.EntityHierarchyKey + '/' +
            this.timeMix.Value;

          //alert('Browsing to: ' + p);

          this.$router.push({
            path: p,
          });
        }
        //
        else {
          this.allDone(p);
        }
      } // find
      else {
        this.allDone(p);
      }
    },

    // getTimeObjFromId(id) {

    // }
    // applyTimeSlotRequirements(timeSlotId, requirementsObject) {
    //     //this.mutateTimeSlotRequirements({ timeSlotId, requirementsObject });
    // }

    allDone(p) {
      //console.log("All Done")
      if (!this.activity) {
        console.error("this.activity must be defined for postTimeSelection.js");
      }
      //
      else {
        // don't copy the entire clone
        // just ocy the specific time-slot from the clone

        // alert('time.Value' + this.time.Value);
        // debugger;

        // let findClonedTimeslot = this.activity.TimesClone.find(ele => {
        //   return ele.Value === this.time.Value;
        // });

        let mainClonedTimeslot = this.activity.Times.find((ele) => {
          return ele.Value === this.time.Value;
        });

        if (!mainClonedTimeslot || !mainClonedTimeslot) {
          console.warn("no mainClonedTimeslot!");
        }
        //
        else {
          //console.log("Attempting to clone")
          let clone = JSON.parse(JSON.stringify(this.time));
          //        console.log("Clone",clone)
          // if this is SimpleTime, you need to unSelect the other times
          if (!this.activeProductDetails.IsLargeGroup) {
            //alert("not large grooup");
            this.activity.Times.forEach((time) => {
              //               console.log("changing IsSelected to false");
              if (time.Value !== this.time.Value) {
                this.$set(time, "IsSelected", false);
              }
            });

            this.activity.TimesClone.forEach((time) => {
              if (time.Value !== this.time.Value) {
                this.$set(time, "IsSelected", false);
              }
            });
          }

          // clean up the SelectedTime to remove any times that are not selected

          /*
          console.log(
            "clone.PickupLocation.LocationName: " +
              clone.PickupLocation.LocationName
          );
*/

          this.$set(mainClonedTimeslot, "PickupLocation", clone.PickupLocation);
          this.$set(mainClonedTimeslot, "PickupLocations", clone.PickupLocations);
          this.$set(mainClonedTimeslot, "Rates", clone.Rates);
          this.$set(mainClonedTimeslot, "AddOns", clone.AddOns);
          this.$set(mainClonedTimeslot, "IsSelected", true);
          this.$set(this.time, "IsSelected", true);

          /*
          console.log("time.Rates", this.time.Rates);
          console.log("time.AddOns", this.time.AddOns);
          console.log("\n time.IsSelected", this.time.IsSelected);

          console.log("mainClonedTimeslot.Rates", mainClonedTimeslot.Rates);
          console.log("mainClonedTimeslot.AddOns", mainClonedTimeslot.AddOns);
*/
        }
        //         console.log("canAutoAddToCart="+this.canAutoAddToCart)
        if (this.canAutoAddToCart) {
          this.addToCartLoading = true;
          setTimeout(() => {
            this.addToCart();
          }, 500);
        } //
        else {
          this.$router.push({
            path: p + "/start",
          });
        }
      }

      // update parent object
    },
  },
  computed: {
    //...mapActions(['ad'])
    ...mapGetters(["activeProductDetails"]),

    canAutoAddToCart() {
      if (
        this.$route.params.modify === "modify" ||
        (this.activeProductDetails.PackageKey && !this.activeProductDetails.ShowFirstActivityOnly) ||
        this.activeProductDetails.IsLargeGroup
      ) {
        return false;
      }
      return true;
    },

    timeMix() {
      if (this.activeProductDetails.PackageKey && !this.activeProductDetails.ShowFirstActivityOnly) {
        return this.time;
      }
      //
      else if (this.activeProductDetails.Activities && this.activeProductDetails.Activities[0].TimesClone) {
        return this.activeProductDetails.Activities[0].TimesClone.find((ele) => {
          return ele.Value == this.timeSlotId;
        });
      }
      return false;
    },

    timeSlotRequirements() {
      // this is a Package
      if (this.activeProductDetails.PackageKey && !this.activeProductDetails.ShowFirstActivityOnly) {
        //alert('timeSlotRequirements Package');
        if (!this.time) {
          //alert('this.time missing in postTimeSelection.js');
        }

        let hasSelectedAddOns = !this.time.AddOns
          ? false
          : this.time.AddOns.find((ele) => {
              return ele.Quantity > 0;
            });

        return [
          {
            page: "guests",
            required: false,
            valid: true,
          },
          {
            page: "foo",
            required: false,
            valid: false,
          },
          {
            page: "pickupLocation",
            required: this.activeProductDetails.NeedTransportation, //this.hasPickupLocations ? true : false,
            valid: !this.time.PickupLocations
              ? null
              : this.time.PickupLocations.find((ele) => {
                  return ele.IsSelected;
                }),
          },
          {
            page: "addOns",
            required: this.timeMix.AddOns && this.timeMix.AddOns.length ? true : false,
            valid: hasSelectedAddOns || this.timeMix.AddOnsSkipped ? true : false,
          },
        ];
      }
      // not a package
      else if (this.activeProductDetails && this.activeProductDetails.Activities && this.activeProductDetails.Activities[0].TimesClone) {
        // debugger;
        console.log(this.activeProductDetails);
        let targetSeletedTime = this.time;

        let guestValid = null;
        let addOnsValid = null;
        let timeHasPickupLocations = null;
        let pickupLocationSelected = null;

        // when large group mode
        if (this.activeProductDetails.IsLargeGroup) {
          // guestValid
          //console.log("large group mode.");
          if (targetSeletedTime) {
            guestValid = targetSeletedTime.Rates.find((ele) => {
              return ele.Participants > 0;
            });
          }
        }

        // simple time mode
        //else {

        if (targetSeletedTime && targetSeletedTime.AddOns) {
          //alert('targetSeletedTime');
          //console.log("else simple time mode.");
          addOnsValid = targetSeletedTime.AddOns.find((ele) => {
            return (ele.Quantity > 0 && !ele.AddOnIsRequired) || ele.Skipped;
          });
          timeHasPickupLocations = targetSeletedTime.PickupLocations && targetSeletedTime.PickupLocations.length ? true : false;
          pickupLocationSelected = !targetSeletedTime.PickupLocations
            ? false
            : targetSeletedTime.PickupLocations.find((ele) => {
                return ele.IsSelected;
              });
        }
        //}

        addOnsValid = addOnsValid ? true : false;
        guestValid = guestValid ? true : false;
        pickupLocationSelected = pickupLocationSelected ? true : false;
        return [
          {
            page: "guests",
            required: this.activeProductDetails.IsLargeGroup ? true : false,
            valid: guestValid,
          },
          {
            page: "pickupLocation",
            required: this.activeProductDetails.NeedTransportation && timeHasPickupLocations, //this.hasPickupLocations ? true : false,
            valid: pickupLocationSelected,
          },
          {
            page: "addOns",
            // required: this.activeProductDetails.Activities[0].HasAddons, //this.time.AddOns ? true : false,
            required:
              this.activeProductDetails.Activities[0].HasAddons ||
              this.activeProductDetails.NeedTransportation ||
              this.activeProductDetails.Activities[0].AddOns.some((a) => !a.IsTransportation),
            valid: addOnsValid,
          },
        ];
      } else {
        console.warn("not returning timeSlotRequirements{} in postTimeSelection.js");
      }
    },
  },
};
